$(document).ready(function() {
    // Collection Product Tab Section 
    const $tabLinks = $('.tab-link');
    const $tabContents = $('.tab-content');
    $tabContents.hide().first().show();
    $tabLinks.first().addClass('active');
    $tabLinks.on('click', function(e) {
      e.preventDefault();
      $tabContents.hide();
      $tabLinks.removeClass('active');
      const tabId = $(this).attr('href');
      $(tabId).show();
      $(this).addClass('active');
    });


    // Blog Tab Section 
    const $BlogtabLinks = $('.blog-nav ul li');
    const $BlogtabContents = $('.blog-tab-content');
    $BlogtabContents.hide().first().show();
    $BlogtabLinks.first().addClass('active');
    $BlogtabLinks.on('click', function(e) {
      e.preventDefault();
      $BlogtabContents.hide();
      $BlogtabLinks.removeClass('active');
      const tabId = $(this).attr('data-href');
      console.log(tabId);
      $(tabId).show();
      $(this).addClass('active');
    });
});

// collection product tab slider

function product_tab_slider() {
  let swiper = new Swiper(".prd-tab-slider-init", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    slidesPerView: 4,
    dynamicBullets: false,
    spaceBetween: 24,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}

$(function () {
    product_tab_slider();
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    product_tab_slider();
  }
);

function download_resources_slider() {
  let swiper = new Swiper(".download-resources", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    createPagination: false,
    freeMode: true,
    slidesPerView: 'auto',
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}

$(function () {
    download_resources_slider();
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    download_resources_slider();
  }
);

function specifications_list_slider() {
  let swiper = new Swiper(".specifications-list", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    slidesPerView: 4,
    dynamicBullets: false,
    spaceBetween: 0,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}

$(function () {
    specifications_list_slider();
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    specifications_list_slider();
  }
);

//Animation Js
document.addEventListener("DOMContentLoaded", function() {
  const revealElements = document.querySelectorAll('.reveal');
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = 1;
          entry.target.style.visibility = 'visible';
          entry.target.style.transform = 'translateY(0)'; // Slide in animation
          observer.unobserve(entry.target); // Stop observing once revealed
        }, 100); 
      }
    });
  });
  
  revealElements.forEach(element => {
    observer.observe(element);
  });
});


// recommended product slider 

function recommended_prd_slider() {
  let swiper = new Swiper(".recommended-slider-init", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    slidesPerView: 4,
    dynamicBullets: false,
    spaceBetween: 24,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}

$(function () {
    recommended_prd_slider();
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    recommended_prd_slider();
  }
);


function about_icon_slider() {
  let swiper = new Swiper(".why-choose-slider", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    grabCursor: true,
    freeMode: true,
    slidesPerView: 4,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      990: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1500: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });
}

$(function () {
    about_icon_slider();
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    about_icon_slider();
  }
);

// Video Gallery Script 
 /* document.addEventListener("DOMContentLoaded", function () {
  const videoItems = document.querySelectorAll(".video-item");

  videoItems.forEach((videoItem) => {
    const video = videoItem.querySelector("video");
    const caption = videoItem.querySelector(".video-item-caption");
    const playIcon = videoItem.querySelector("svg");

    playIcon.addEventListener("click", function (event) {
      event.stopPropagation(); 

      videoItems.forEach((item) => {
        const otherVideo = item.querySelector("video");
        const otherCaption = item.querySelector(".video-item-caption");

        if (otherVideo !== video) {
          otherVideo.pause();
          otherCaption.style.display = "flex"; 
        }
      });

      if (video.paused) {
        video.play();
        caption.style.display = "none"; 
      }
    });

    video.addEventListener("ended", function () {
      caption.style.display = "flex";
    });
  });

  document.addEventListener("click", function () {
    videoItems.forEach((videoItem) => {
      const video = videoItem.querySelector("video");
      const caption = videoItem.querySelector(".video-item-caption");

      if (!video.paused) {
        video.pause();
        caption.style.display = "flex"; 
      }
    });
  });
}); */

// Image Gallery Script 

const modal = document.getElementById("imageModal");
const modalImage = document.getElementById("modalImage");
const closeButton = document.querySelector(".close-btn");

document.querySelectorAll(".image-item svg").forEach(svg => {
  svg.addEventListener("click", function () {
    const imgSrc = this.parentElement.querySelector("img").src;
    modalImage.src = imgSrc;
    modal.classList.add("active"); 
  });
});

if (closeButton) {
  closeButton.addEventListener("click", () => {
    modal.classList.remove("active");
  });
}

window.addEventListener("click", (e) => {
  if (e.target === modal) {
    modal.classList.remove("active");
  }
});

//Sticky ATC 
$(document).ready(function() {
    var $announcementBar = $('.sticky-atc');
    var productFormEndOffset = calculateOffset();
    var windowHeight = $(window).height();

    // Function to calculate the offset dynamically
    function calculateOffset() {
        return $('.product-form__buttons').offset().top + $('.product-form__buttons').outerHeight();
    }

    $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();

        // For desktop (larger than 1024px)
        if ($(window).width() > 1024) {
            if (scrollTop >= productFormEndOffset) {
                $announcementBar.css('top', '0');
            } else {
                $announcementBar.css('top', '-200px');
            }
        } else {
            // For mobile (smaller than 1024px)
            if (scrollTop + windowHeight >= productFormEndOffset) {
                $announcementBar.css('bottom', '0');
            } else {
                $announcementBar.css('bottom', '-200px');
            }
        }
    });

    // Recalculate on resize
    $(window).on('resize', function() {
        productFormEndOffset = calculateOffset();
        windowHeight = $(window).height();
    });
});

 
 
